import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class OrganizationScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentOrganization: {id: null, 
                                        shortname: "", 
                                        name: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeShortName = this.handleChangeShortName.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.organization && this.props.args.organization.length > 0) {
            BaseApi.get("/project/organization", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.organization}, withCredentials: true})
            .then(res => { 
                this.setState({currentOrganization: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/project/organization', this.state.currentOrganization, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentOrganization = this.state.currentOrganization
            currentOrganization.id = res.data.id
            this.setState({currentOrganization: currentOrganization})
            this.props.args.organizatioin = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentOrganization = this.state.currentOrganization
        currentOrganization.name = event.target.value
        this.setState({currentOrganization: currentOrganization})
    }

    handleChangeShortName(event) {
        var currentOrganization = this.state.currentOrganization
        currentOrganization.shortname = event.target.value
        this.setState({currentOrganization: currentOrganization})
    }

    /*openEvents() {
        this.props.navigate("events", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProducts() {
        this.props.navigate("products", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProgramContracts() {
        this.props.navigate("contract-programs", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id, caption: "Контракты", program: this.state.currentProgram})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "program", callargs: this.props.args, refrecid: this.state.currentProgram.id})    
    } */

    render() {
        const organizationExists = !!this.state.currentOrganization.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Организация"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {organizationExists ? "Редактирование организации" : "Новая организация"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="shortname"> Краткое наименование:</label>
                                        <input 
                                            type="text" 
                                            class="form-control w-100" 
                                            id="shortname" value={this.state.currentOrganization.shortname} 
                                            onChange={this.handleChangeShortName} />
                                        <label for="name">Полное наименование:</label>
                                        <input 
                                            type="text" 
                                            class="form-control w-100" 
                                            id="name"  
                                            value={this.state.currentOrganization.name} 
                                            onChange={this.handleChangeName} />
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                                {/*
                                {organizationExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>      
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProducts()}}>
                                                Продукты
                                        </button>                             
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProgramContracts()}}>
                                                Контракты
                                        </button>   
                                        <button 
                                             className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openRefs()}}>
                                                Ссылки
                                        </button>   
                            
                                    </div>
                                )}
                                */}    
                                {!organizationExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/organization.js